const FETCH_GUARD_FLAG = '__livewire419ReloadGuardInstalled';
const RELOAD_STATE_KEY = 'livewire_419_reload_state';
const LOGOUT_FORM_LOCK_FLAG = '__logoutFormSubmitLockInstalled';
const LIVEWIRE_419_HOOK_FLAG = '__livewire419HookInstalled';
const RELOAD_WINDOW_MS = 2 * 60 * 1000;
const MAX_RELOADS_PER_WINDOW = 2;

export function installLivewireGuard() {
    installLogoutFormSubmitLock();
    installLivewire419Handler();

    if (typeof window === 'undefined' || typeof window.fetch !== 'function') {
        return;
    }

    if (window[FETCH_GUARD_FLAG] === true) {
        return;
    }

    const originalFetch = window.fetch.bind(window);

    window.fetch = async function (input, init) {
        const response = await originalFetch(input, init);

        try {
            const requestUrl = typeof input === 'string' ? input : input?.url;
            const isLivewireUpdate = typeof requestUrl === 'string' && requestUrl.includes('/livewire/update');
            const shouldReload = isLivewireUpdate && response.status === 419;

            if (shouldReload) {
                reloadOnceAfter419();
            } else if (response.ok) {
                clearReloadState();
            }
        } catch (e) {
            // Never block the original fetch flow.
        }

        return response;
    };

    window[FETCH_GUARD_FLAG] = true;
}

function installLivewire419Handler() {
    if (typeof window === 'undefined' || window[LIVEWIRE_419_HOOK_FLAG] === true) {
        return;
    }

    const registerHandler = () => {
        if (typeof window.Livewire === 'undefined' || typeof window.Livewire.hook !== 'function') {
            return;
        }

        window.Livewire.hook('request', ({ fail }) => {
            fail(({ status, preventDefault }) => {
                if (status !== 419) {
                    return;
                }

                if (typeof preventDefault === 'function') {
                    preventDefault();
                }

                reloadOnceAfter419();
            });
        });

        window[LIVEWIRE_419_HOOK_FLAG] = true;
    };

    registerHandler();
    document.addEventListener('livewire:initialized', registerHandler, { once: true });
}

function reloadOnceAfter419() {
    const state = getReloadState();
    const now = Date.now();
    const isWindowExpired = now - state.lastReloadAt > RELOAD_WINDOW_MS;

    if (isWindowExpired) {
        state.count = 0;
    }

    if (state.count >= MAX_RELOADS_PER_WINDOW) {
        return;
    }

    state.count += 1;
    state.lastReloadAt = now;
    sessionStorage.setItem(RELOAD_STATE_KEY, JSON.stringify(state));
    window.location.reload();
}

function getReloadState() {
    try {
        const raw = sessionStorage.getItem(RELOAD_STATE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;

        if (
            parsed
            && Number.isInteger(parsed.count)
            && Number.isInteger(parsed.lastReloadAt)
        ) {
            return parsed;
        }
    } catch (e) {
        // Ignore malformed state and return defaults below.
    }

    return {
        count: 0,
        lastReloadAt: 0,
    };
}

function clearReloadState() {
    sessionStorage.removeItem(RELOAD_STATE_KEY);
}

function installLogoutFormSubmitLock() {
    if (window[LOGOUT_FORM_LOCK_FLAG] === true || typeof document === 'undefined') {
        return;
    }

    document.addEventListener('submit', (event) => {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) {
            return;
        }

        const action = form.getAttribute('action') || '';
        const isLogoutForm = action.endsWith('/portal/logout');

        if (!isLogoutForm) {
            return;
        }

        if (form.dataset.logoutSubmitting === '1') {
            event.preventDefault();
            return;
        }

        form.dataset.logoutSubmitting = '1';

        const submitter = event.submitter;
        if (submitter && 'disabled' in submitter) {
            submitter.disabled = true;
        }
    }, true);

    window[LOGOUT_FORM_LOCK_FLAG] = true;
}
